import React from 'react';
import { useCopyClient } from '@members/copy/CopyProvider';
import CopyProvider from '@members/copy/CopyProvider/CopyProvider';
import Oops from '@members/errors/Oops';
import { GlobalStyles } from './GlobalStyles';

export const ErrorPage = () => {
  const copyClient = useCopyClient();
  return (
    <CopyProvider copyClient={copyClient}>
      <GlobalStyles />
      <Oops />
    </CopyProvider>
  );
};
